import type { IComponent } from "@Components/Component";

export enum HeaderType {
    Default = 0,
    LandingPages = 1,
    None = 2,
}

export type IBaseHeader = IComponent & {
    headerType: HeaderType;
};
